/* global __webpack_public_path__ */

if (typeof window !== "undefined" && window.location.protocol === "file:") {
  __webpack_public_path__ = new URL("./", window.location.href).href;
}
